<template>
  <el-dialog
    class="dialog-container"
    :visible.sync="dialogVisible"
    width="1300px !important"
    append-to-body
    destroy-on-close
  >
    <div slot="title" class="header-title">
      <img src="@/assets/image/newIssue.png" alt="" />
      <span>{{ $t("upgrade.selectVIN") }}</span>
    </div>
    <div>
      <div class="filter-container">
        <el-form
          :inline="true"
          ref="queryParams"
          :model="queryForm"
          :label-width="labelWidth"
        >
          <!-- VIN -->
          <el-form-item label="VIN:">
            <el-input
              v-model="queryParams.vin"
              :placeholder="$t('placeholder.enter')"
            ></el-input>
          </el-form-item>
          <!-- 品牌 -->
          <el-form-item :label="$t('home.brand') + ':'">
            <el-input
              v-model="queryParams.carBrand"
              :placeholder="$t('placeholder.enter')"
            ></el-input>
          </el-form-item>
          <!-- 车型 -->
          <el-form-item :label="$t('home.carType') + ':'">
            <el-input
              v-model="queryParams.carModel"
              :placeholder="$t('placeholder.enter')"
            ></el-input>
          </el-form-item>
          <!-- 订单号 -->
          <el-form-item :label="$t('cart.orderNumber') + ':'">
            <el-input
              v-model="queryParams.orderNum"
              :placeholder="$t('placeholder.enter')"
            ></el-input>
          </el-form-item>
        </el-form>
        <div class="searchButton">
          <div></div>
          <div>
            <el-button class="primary-btn" type="primary" @click="searchClick()">
              <i class="subSearch-icon"></i>
              {{ $t("home.query") }}
            </el-button>
            <el-button class="primary-btn" plain @click="resetClick()">
              <i class="el-icon-refresh-right"></i>
              {{ $t("home.reset") }}
            </el-button>
          </div>
        </div>
      </div>
      <div class="infoDetail">
        <el-row>
          <el-col :span="17">
            <div>
              <el-table
                :data="detailList"
                style="width: 100%"
                ref="table"
                :height="tableHeight"
                highlight-current-row
                border
                stripe
                row-key="id"
                @selection-change="handleSelection"
              >
                <el-table-column
                  type="selection"
                  width="40"
                  fixed="left"
                  align="center"
                  reserve-selection
                ></el-table-column>
                <!-- 序号 -->
                <el-table-column
                  :label="$t('cart.xh')"
                  width="60px"
                  align="center"
                  :render-header="$globalRenderHeader"
                >
                  <template slot-scope="scope">
                    {{ scope.$index + 1 }}
                  </template>
                </el-table-column>
                <!-- VIN -->
                <el-table-column
                  label="VIN"
                  min-width="180"
                  prop="vin"
                  :render-header="$globalRenderHeader"
                ></el-table-column>
                <!-- 品牌 -->
                <el-table-column
                  :label="$t('home.brand')"
                  min-width="120"
                  prop="carBrand"
                  :render-header="$globalRenderHeader"
                ></el-table-column>
                <!-- 车型 -->
                <el-table-column
                  :label="$t('home.carType')"
                  min-width="120"
                  prop="carModel"
                  :render-header="$globalRenderHeader"
                ></el-table-column>
                <!-- 订单号 -->
                <el-table-column
                  :label="$t('cart.orderNumber')"
                  min-width="130"
                  prop="orderNum"
                  :render-header="$globalRenderHeader"
                ></el-table-column>
                <!-- 生产日期 -->
                <el-table-column
                  :label="$t('seek.produceDate')"
                  width="160"
                  align="center"
                  prop="productionDate"
                  :render-header="$globalRenderHeader"
                ></el-table-column>
              </el-table>
              <div class="fenye">
                <pagination
                  v-if="total > 0"
                  :total="total"
                  :page.sync="pageNum"
                  :limit.sync="pageSize"
                  @pagination="handlePaginationChange"
                />
              </div>
            </div>
          </el-col>
          <el-col :span="7">
            <el-table
              style="width: 100%"
              ref="applytable"
              :height="maxHeight"
              border
              stripe
              highlight-current-row
              :data="vinSelectList"
              :header-cell-style="{}"
              @cell-mouse-enter="cellMouseEnter"
              @cell-mouse-leave="cellLeaveEnter"
            >
              <el-table-column prop="title">
                <template slot="header">
                  <div class="authorityTitle">
                    <div>
                      <span
                        >{{ $t("upgrade.selected") }}(<b> {{ selectNum }} </b
                        >)</span
                      >
                    </div>
                    <div>
                      <span class="textStyle" @click="selectAll">{{
                        $t("upgrade.selectAll")
                      }}</span>
                      <span class="textStyle clearAction" @click="cancelAll">{{
                        $t("upgrade.cancelAll")
                      }}</span>
                    </div>
                  </div>
                </template>
                <template slot-scope="scope">
                  <div :class="'nationalList ' + '_' + scope.row.id">
                    <span>{{ scope.row.vin }}</span>
                    <i
                      class="el-icon-close"
                      @click="deleteEmpower(scope.row)"
                    ></i>
                  </div>
                </template>
              </el-table-column>
            </el-table>
          </el-col>
        </el-row>
        <div class="flex_default_center">
          <el-button @click="handelConfirm" class="primary-btn lang-but" type="primary">{{
            $t("home.confirm")
          }}</el-button>
          <el-button
            class="primary-btn lang-but"
            plain
            @click="dialogVisible = false"
            >{{ $t("seek.cancel") }}</el-button
          >
        </div>
      </div>
    </div>
  </el-dialog>
</template>
<script>
import { getVinHandleList } from '@/api/vehicleUpgrade';
export default {
  props: {
    upgradeOrderId: {
      type: String,
      default: "",
    }
  },
  data() {
    return {
      dialogVisible: false,
      queryParams: {
        completeStatus: "1"
      },
      detailList: [],
      selectNum: 0,
      vinSelectList: [],
      total: 0,
      pageNum: 1,
      pageSize: 15,
      tableHeight: 0,
      maxHeight: 0,
      carInfoList: [],
    };
  },
  computed: {
    labelWidth() {
      const widthMap = {
        zh: "60px",
        en: "115px",
        es: "145px",
        vi: "100px",
        fa: "105px",
      };
      return widthMap[this.$i18n.locale] || "160px";
    },
  },
  methods: {
    // 初始化
    async init(data) {
      this.dialogVisible = true;
      this.carInfoList = data;
      this.selectNum = 0;
      this.vinSelectList = [];
      this.resetClick();
      this.getVinData()
      this.sizeArea();
    },
    getParams() {
      const params = { ...JSON.parse(JSON.stringify(this.queryParams)) };
      return {
        data: {
          ...params,
        },
        page: {
          pageNum: this.pageNum,
          pageSize: this.pageSize,
        },
      };
    },
    // 获取数据
    getVinData() {
      var params = this.getParams();
      // 写入当前索赔单id
      params.data.upgradeOrderId = this.upgradeOrderId;
      getVinHandleList(params).then((res) => {
        if (res.status == 0) {
          var list = res.data.records;
          // 提取车辆信息中所有的vin
          const carVin = new Set(this.carInfoList.map(item => item.vin));
          // 过滤list中vin
          var result = list.filter(item => !carVin.has(item.vin));
          this.detailList = result;
          this.total = res.data.count;
        }
      })
    },
    // 搜索
    searchClick() {
      this.pageNum = 1;
      this.getVinData();
    },
    // 重置
    resetClick() {
      this.queryParams = {};
      this.$nextTick(() => {
        this.$refs.queryParams.resetFields();
      });
      this.searchClick();
    },
    // 分页
    handlePaginationChange(val) {
      this.pageNum = val.page;
      this.pageSize = val.limit;
      this.getVinData();
    },
    // 多选
    handleSelection(val) {
      this.selectNum = val.length;
      this.vinSelectList = val;
    },
    // 选择全部
    selectAll() {
      var _this = this;
      var params = this.getParams();
      params.page.pageNum = 1;
      params.page.pageSize = 99999;
      let selectList = []
      getVinHandleList(params).then((res) => {
        if (res.status == 0) {
          var list = res.data.records;
          const carVin = new Set(this.carInfoList.map(item => item.vin));
          var result = list.filter(item => !carVin.has(item.vin));
          result.forEach((row) => {
            selectList.push(row);
            _this.$nextTick(() =>{
              _this.$refs.table.toggleRowSelection(row, true)
            })
          })
          this.handleSelection(selectList);
        }
      })
    },
    // 取消全部
    cancelAll() {
      this.vinSelectList = [];
      this.handleSelection([]);
      this.$refs.table.clearSelection();
      this.$refs.applytable.clearSelection();
    },
    // 删除
    cellMouseEnter(row) {
      $(".nationalList._" + row.id + " .el-icon-close").show();
    },
    cellLeaveEnter() {
      $(".nationalList .el-icon-close").hide();
    },
    deleteEmpower(row) {
      let _this = this;
      _this.$nextTick(() => {
        _this.$refs.table.toggleRowSelection(row, false);
      });
      var deleteInfo = _this.detailList.find((item) => item.id == row.id);
      if (deleteInfo) {
        _this.$refs.table.toggleRowSelection(deleteInfo, false);
      } else {
        var newArray = _this.vinSelectList.filter((item) => item.id !== row.id);
        _this.vinSelectList = newArray;
        _this.selectNum = _this.vinSelectList.length;
        if (_this.selectNum == 0) {
          this.cancelAll();
        }
      }
    },
    // 确定
    handelConfirm() {
      console.log(this.vinSelectList);
      this.$emit("success", this.vinSelectList);
      this.dialogVisible = false;
    },
    // 内容高度
    heightArea() {
      setTimeout(() => {
        var allHeight = $(".dialog-container .infoDetail").outerHeight(true);
        var pageHeight = Math.ceil(
          $(".pagination-container").length > 0
            ? $(".pagination-container").outerHeight(true)
            : 0
        );
        var butHeight = $(".flex_default_center").outerHeight(true);
        this.tableHeight = allHeight - pageHeight - butHeight;
        this.maxHeight = allHeight - butHeight;
      }, 100);
    },
    sizeArea() {
      var _this = this;
      _this.heightArea();
      window.addEventListener("resize", () => {
        _this.heightArea();
      });
    },
  },
  mounted() {},
};
</script>
<style scoped>
.infoDetail {
  height: 580px;
}
/* 分页 */
.pagination-container {
  border: 1px solid var(--table-color);
  border-top: none;
  background: #fff;
}
/* 右侧内容 */
.authorityTitle,
.nationalList {
  display: flex;
  justify-content: space-between;
  align-items: center;
}
/* 按钮 */
.authorityTitle span {
  margin: 0 5px;
  /* color: #909399; */
}
.authorityTitle .textStyle {
  color: var(--theme-color);
  cursor: pointer;
  font-size: 14px;
  font-weight: normal;
}
.authorityTitle .clearAction {
  color: var(--nav-bgColor);
}
.authorityTitle span b {
  color: var(--theme-color);
}
/* 列表内容 */
.nationalList span {
  display: inline-block;
  flex: 1;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.nationalList i {
  cursor: pointer;
  display: none;
  font-size: 13px;
  font-weight: bold;
}
.nationalList i:hover {
  color: #d91c1c;
}
</style>
